import { IApiClient } from '@base/features/api/model/apiClient';
import { GamesHistory, IGamesHistoryService } from './interfaces';
import API_PATHS from '@base/features/api/constants/apiPaths';
import {Moment} from 'moment';

class GamesHistoryService implements IGamesHistoryService {
  constructor(private gameId: number, private apiClient: IApiClient) {}
  async getMat(logId: number, gameId?: number) {
    const res = await this.apiClient.authGet(
      {
        // gameid: gameId ? gameId : this.gameId,
        id: logId,
        mat: 1,
        json: 1,
      },
      API_PATHS.gameview
    );
    return await res.json();
  }

  async getGameLog(logId: number, gameId?: number) {
    const res = await this.apiClient.authGet(
      {
        // gameid: gameId ? gameId : this.gameId,
        id: logId,
        mat: 1,
        json: 1,
      },
      API_PATHS.gameview
    );
    const data = await res.json();
    return data.Log;
  }

  async getGamesHistory(gameId?: number, date?: Moment): Promise<GamesHistory[]> {
    if (!date) {
      const res = await this.apiClient.authGet(
        {
          gameid: gameId ? gameId : this.gameId,
          json: 1,
        },
        API_PATHS.gameview
      );
      const data = await res.json();
      return data.rows;
    }
    const [fyyyy, fmm, fdd] = date.format('YYYY-MM-DD').split('-');
    const res = await this.apiClient.authGet(
      {
        gameid: gameId ? gameId : this.gameId,
        fmm,
        fdd,
        fyyyy,
        json: 1,
      },
      API_PATHS.gameview
    );
    const data = await res.json();
    return data.rows;
  }
}

export default GamesHistoryService;
